import { render, staticRenderFns } from "./formwork.vue?vue&type=template&id=082f542b&scoped=true&"
import script from "./formwork.vue?vue&type=script&lang=js&"
export * from "./formwork.vue?vue&type=script&lang=js&"
import style0 from "./formwork.vue?vue&type=style&index=0&id=082f542b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f542b",
  null
  
)

export default component.exports